export const WALLET_TRANSFER = "WALLET";
export const BANK_TRANSFER = "FIAT";
export const CRYPTO = "CRYPTO";
export const COINBASE = "COINBASE";
export const GEMINI = "GEMINI";
export const BANKS_ARR = ["dwolla", "fiat", "bank", "silamoney"];
export const DWOLLA = "DWOLLA";
export const SILAMONEY = "SILAMONEY";
export const DEFAULT_CURRENCY = "USD";
export const BANK = "BANK ";
export const CRYPTO_WALLET = "CRYPTO-WALLET";
export const TOKEN_FREE_APIS = ["autologin", "signin", "order-details"];
// export const TOKEN_FREE_APIS = ["autologin", "signin"];
export const TABS_OPTION = ["crypto", "bank", "wallet"];
export const CRYPTO_TAB = "Crypto Exchange";
export const WALLET_TAB = "Crypto Wallet";
export const BANKS_TAB = "Bank Transfer";
export const BUY_CRYPTO = "Buy Crypto";
export const EXCHANGES = [
  {
    name: "okcoin",
    textfields: [
      {
        key: "apikey",
        name: "Api Key",
        value: "",
        video:
          "https://dev-rocketfuel-videos.s3.amazonaws.com/API+-+Okcoin+%E2%80%93+Leading+Global+Digital+Asset+Exchange.mp4",
      },
      {
        key: "secretKey",
        name: "Secret Key",
        value: "",
        video: "",
      },
      {
        key: "paraphrase",
        name: "Passphrase",
        value: "",
        video: "",
      },
      // {
      //   key: "password",
      //   value: "",
      //   name: "Fund Password",
      //   video:
      //     "https://dev-rocketfuel-videos.s3.amazonaws.com/Account+security+-+Okcoin+%E2%80%93+Leading+Global+Digital+Asset+Exchange.mp4",
      // },
    ],
    whiteListKeys: [
      {
        text: "Select a currency you will be paying with",
        key: "Whitelist Address",
        value: "",
        video:
          "https://dev-rocketfuel-videos.s3.amazonaws.com/address_whitelist.mp4",
      },
    ],
    getApiKey: "https://www.okcoin.com/account/my-api",
    externalField: {
      name: "Address Whitelabel",
      text: "choose a coin to get a address.",
    },
    whitelistUrl:
      "https://dev-rocketfuel-videos.s3.amazonaws.com/address_whitelist.mp4",
  },
  {
    name: "binanceUS",
    textfields: [
      {
        key: "apikey",
        name: "Api Key",
        value: "",
        video:
          "https://dev-rocketfuel-videos.s3.amazonaws.com/API+-+Okcoin+%E2%80%93+Leading+Global+Digital+Asset+Exchange.mp4",
      },
      {
        key: "secretKey",
        name: "Secret Key",
        value: "",
      },
    ],
    getApiKey: "https://www.binance.us/en/home",
    externalField: {
      name: "Address Whitelabel",
      text: "choose a coin to get a address.",
    },
  },
  {
    name: "kraken",
    textfields: [
      {
        key: "apikey",
        name: "Api Key",
        value: "",
        video:
          "https://dev-rocketfuel-videos.s3.amazonaws.com/kraken_apisecret.mp4",
      },
      {
        key: "secretKey",
        name: "Secret Key",
        value: "",
      },
      // {
      //   key: 'password',
      //   name: 'Address Key',
      //   value: '',
      //   video: 'https://dev-rocketfuel-videos.s3.amazonaws.com/kraken_address_whitelist.mp4',
      // },
    ],
    whiteListKeys: [
      {
        text: "Whitelist the Crypto address to get the Address key.",
        key: "Whitelist Address",
        value: "",
      },
      {
        text: "Add this Address key to Kraken",
        key: "Whitelist Address",
        value: "",
      },
    ],
    getApiKey: "https://www.binance.us/en/home",
    externalField: {
      name: "Address Whitelabel",
      text: "choose a coin to get a address.",
    },
  },
];
export const BITCOIN_NETWORK = "bip122";
export const CCD_NETWORK = "ccd";
export const CCD_NETWORK_TOKENS = ["CCD", "EURR", "USDR"];
